module.exports = __webpack_public_path__ + "assets/img/timeLine_img6.a00ad72e.png";